export default __webpack_public_path__ + "static/media/Mech decker.371fe09f.png";